<mib-modal fullScreenOnPhone closeLabel="Close the filters">
  <span mib-modal-header class="flex items-center gap-2">
    <svg mib-icon name="funnel" class="size-4" aria-hidden="true"></svg>
    Filters
    @if (library.hasFilters()) {
      <span class="text-sm">({{ library.filterCount() }})</span>
    }
  </span>

  @if (library.hasFilters()) {
    <button
      mibButton
      type="button"
      mode="link"
      class="no-underline"
      mib-modal-header-end
      (click)="resetFilters()">
      Reset
    </button>
  }

  <div mib-modal-content>
    <mai-case-filter-panel [sortable]="true"></mai-case-filter-panel>
  </div>

  <button
    mibButton
    type="button"
    size="lg"
    class="w-full"
    aria-live="polite"
    mib-modal-footer
    (click)="modal().close()">
    {{ resultsActionLabel() }}
  </button>
</mib-modal>
